import $ from 'jquery';
import 'slick-carousel';

function accolades_slider() {

$(document).ready(function() {

    $('.accolades .flex-row-wrapper').slick({
        infinite: true,
        autoplay: true,
        arrows: false,
        slidesToShow: 3,
        slidestoScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidestoScroll: 1,
                    infinite: true,
                    autoplay: true,
                }
            }
        ]
    });

});


}   

export default accolades_slider;


